
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-production/real-estate-explainer-video",
      function () {
        return require("private-next-pages/video-production/real-estate-explainer-video/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-production/real-estate-explainer-video"])
      });
    }
  